/* @flow */

import React from 'react';
import { FormattedMessage } from 'react-intl';

import Avatar from '@uniiverse/library/components/avatar';
import CameraIcon from '@uniiverse/library/assets/icons/camera.svg';
import Config from 'config';
import { isPrivate } from '../../../modules/profile/getters';

// import style from './index-module.css';
import './styles.css';

type Props = {
  data: ProfileQuery,
  currentUser: Object,
  csrfToken: string
};

const editableAvatar: Function = (avatar: React$Element<*>): React$Element<*> => {
  const selectAvatar = () => {
    const input = document.querySelector('.uploader');

    if (input) {
      input.click();
    }
  };
  const uploadAvatar = async () => {
    const input = document.querySelector('.uploader');
    if (!input || !(input instanceof HTMLInputElement) || !input.files[0].size) {
      return;
    }

    const data = new FormData();
    data.append('photo[photo]', input.files[0]);

    await fetch(`${Config.api.host}/account/avatars.json`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: new Headers({ 'X-CSRF-Token': window.sessionStorage.csrf_token }),
      body: data
    });

    window.location.reload();
  };

  return (
    <div className="editableContainer">
      <a className="editAvatar" onClick={selectAvatar}>
        {avatar}
        <input type="file" className="uploader" onChange={uploadAvatar} accept="image/png, image/jpeg" />
        <span className="uploadText">
          <CameraIcon />
          <FormattedMessage id="profile.change-avatar" defaultMessage="Change avatar" />
        </span>
      </a>
    </div>
  );
};

const EmptyAvatar: Function = (props: Props): React$Element<*> => {
  const { data: { profile }} = props;

  const user = {
    id: profile.id,
    first_name: profile.firstName,
    last_name: profile.lastName
  };

  return <Avatar user={user} size="xlarge" />;
};

const ProfileAvatar: Function = (props: Props): React$Element<*> => {
  const { data: { profile }, currentUser } = props;
  const userOwnsProfile = currentUser && currentUser.id === profile.id;
  let avatar;

  if (!profile.avatarUrl || (isPrivate(profile) && !userOwnsProfile)) {
    avatar = <EmptyAvatar {...props} />;
  }
  else {
    avatar = (
      <Avatar
        user={{ image_url_160: profile.avatarUrl }}
        size="xlarge"
      />
    );
  }

  if (userOwnsProfile) {
    return editableAvatar(avatar, props);
  }

  return <div>{avatar}</div>;
};

export default ProfileAvatar;



// WEBPACK FOOTER //
// ./src/components/profile/avatar/index.js